export enum AppTopBarNotificationsTab {
    New = "new",
    Previous = "previous",
}

export const NOTIFICATIONS_FIRST_PAGE = 1;
// Known accepted limitation: New renders only the first N unread notifications with no pager;
// closing acknowledges all matching unread notifications, including those beyond N.
export const NEW_NOTIFICATIONS_PAGE_SIZE = 20;
export const PREVIOUS_NOTIFICATIONS_PAGE_SIZE = 10;
export const UNREAD_COUNT_PAGE_SIZE = 1;

export const NOTIFICATIONS_DIALOG_MAX_HEIGHT = "80vh";
export const NOTIFICATIONS_HEADER_ACCENT_WIDTH_PX = 6;
export const NOTIFICATIONS_CARD_ACCENT_WIDTH_PX = 4;
export const NOTIFICATIONS_TIMELINE_DOT_BORDER_WIDTH_PX = 3;

export const NOTIFICATIONS_TIMELINE_GEOMETRY = {
    lineLeftPx: 20,
    lineWidthPx: 2,
    dotLeftPx: 12,
    dotTopPx: 8,
    dotDiameterPx: 16,
    dotBorderRadius: "50%",
} as const;

export const NOTIFICATIONS_SKELETON_WIDTHS = {
    date: "30%",
    title: "60%",
    firstBodyLine: "100%",
    secondBodyLine: "85%",
} as const;

export const APP_TOP_BAR_NOTIFICATIONS_DIALOG_TITLE_ID =
    "app-top-bar-notifications-dialog-title";

interface NotificationsEmptyStateCopy {
    title: string;
    message: string;
}

interface NotificationsErrorStateCopy {
    title: string;
    message: string;
}

export const APP_TOP_BAR_NOTIFICATIONS_COPY = {
    dialogTitle: "Notifications",
    bellButtonLabel: "Notifications",
    closeButtonLabel: "Close notifications",
    toggleGroupLabel: "Notification view",
    unreadLabel: "unread",
    newTabLabel: "New",
    previousTabLabel: "Previous",
    nextPageLabel: "Next",
    pageLabel: "Page",
    pageCountSeparator: "of",
    bugFixLabel: "Bug Fix",
    userManualLabel: "View User Manual",
} as const;

export const APP_TOP_BAR_NOTIFICATIONS_EMPTY_STATE_COPY: Record<
    AppTopBarNotificationsTab,
    NotificationsEmptyStateCopy
> = {
    [AppTopBarNotificationsTab.New]: {
        title: "You're all caught up",
        message: "No new notifications.",
    },
    [AppTopBarNotificationsTab.Previous]: {
        title: "No previous notifications",
        message: "Read notifications will appear here.",
    },
};

export const APP_TOP_BAR_NOTIFICATIONS_ERROR_STATE_COPY: Record<
    AppTopBarNotificationsTab,
    NotificationsErrorStateCopy
> = {
    [AppTopBarNotificationsTab.New]: {
        title: "Unable to load notifications",
        message: "Please try again.",
    },
    [AppTopBarNotificationsTab.Previous]: {
        title: "Unable to load previous notifications",
        message: "Please try again.",
    },
};

export const APP_TOP_BAR_NOTIFICATIONS_RETRY_LABEL = "Retry";

export const APP_TOP_BAR_NOTIFICATIONS_ERROR_MESSAGES = {
    unreadCount: "Failed to fetch unread notification count:",
    newNotifications: "Failed to fetch new notifications:",
    previousNotifications: "Failed to fetch previous notifications:",
    markAllAsRead: "Failed to mark all notifications as read:",
} as const;
